import { Component, Injector, OnInit } from '@angular/core';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { Validators } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { GlobalAddVehicleComponent } from 'src/app/shared/modals/global-add-vehicle/global-add-vehicle.component';

@Component({
    selector: 'app-editvaletinventory',
    templateUrl: './editvaletinventory.component.html',
    styleUrls: ['./editvaletinventory.component.scss'],
    standalone: false
})
export class EditValetInventoryComponent extends ModelEditor implements OnInit {
  
  public ValetStations: any[] = [];
  public ValetTypes: any[] = [];
  public RateSets: any[] | null = null;
  
  constructor(private injector: Injector, private apiService: ApiServiceBase, private modalService: SimpleModalService) {
    super("valet/inventory", injector);
    this.apiService.Get<any>("valet/stations").then(result => {
      this.ValetStations = result;
    });
    this.apiService.Get<any>("valet/types").then(result => {
      this.ValetTypes = result;
    });
    this.apiService.Post<any>("parking/ratesets/searches", { PageNumber: 1, PageSize: 9999, Page: 1 })
    .then(result => {
      this.RateSets = result.Results;
    });
  }

  public override DefaultModel(): any {
    return {
      ValetStationId: null,
      KeyTagIdentifier: "",
      CustomerPhoneNumber: "",
      CustomerFirstName: "",
      CustomerLastName: "",
      ValetTypeId: null,
      VehicleId: null,
      RegistrationNumber: "",
      VehicleBrandId: null,
      VehicleModelId: null,
      VehicleColorId: null,
      ParkingRateSetId: null,
      KeyState: 1
    };
  }

  public override AfterModelLoaded(): void {
    if (this.Model.SmsOptedIn) {
      this.Form.get('CustomerPhoneNumber')?.disable();
    }
  }

  public override BeforeSave(): void {
  }

  public override Validators(): any {
    return {
      'ValetStationId': [Validators.required],
      'CustomerPhoneNumber': [Validators.maxLength(20), Validators.pattern(/^\d*$/)]
    };
  }

  public RemoveVehicle(){
      this.Model.VehicleId = null;
      this.Form.markAsDirty();
    }
  
    public AddVehicle(){
        this.modalService.addModal(GlobalAddVehicleComponent).subscribe(result => {
          console.log(result);
          this.Model.VehicleId = result.Id;
          this.Form.patchValue({VehicleId: result.Id});
          this.Model.VehicleBrandName = result.Brand;
          this.Model.VehicleModelName = result.Model;
          this.Model.VehicleColorName = result.Color;
          this.Model.PlateNumber = result.PlateNumber;
          this.Form.markAsDirty();
        })
    };
}
